<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style>
@import 'assets/css/common.css';
@import 'assets/css/demo1.css';
@import 'assets/css/demo2.css';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  height: auto;
  background: rgb(143, 20, 19);
}
/*.mineblue{*/
/*  color: rgb(47,70,191);*/
/*}*/
img {
  object-fit: cover;
}
</style>
